import QRCode from "qrcode";

async function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

export async function toDataUrl(url) {
  const blob = await fetch(url).then((r) => r.blob());
  return new Promise((resolve) => {
    const fr = new FileReader();
    fr.onload = () => resolve(fr.result);
    fr.readAsDataURL(blob);
  });
}

const qrOpts = (o) => ({ errorCorrectionLevel: o.logo ? "H" : o.ecl, margin: o.margin, color: { dark: o.fg, light: o.bg } });

export async function buildSvg(text, o) {
  let svg = await QRCode.toString(text, { ...qrOpts(o), type: "svg" });
  const size = Number(svg.match(/viewBox="0 0 (\d+) \d+"/)[1]);
  svg = svg.replace("<svg ", '<svg width="1024" height="1024" xmlns:xlink="http://www.w3.org/1999/xlink" ');
  if (o.logo) {
    const s = size * o.logoScale;
    const x = (size - s) / 2;
    const pad = s * 0.12;
    const overlay =
      `<rect x="${x - pad}" y="${x - pad}" width="${s + 2 * pad}" height="${s + 2 * pad}" rx="${pad}" fill="${o.bg}"/>` +
      `<image xlink:href="${o.logo}" href="${o.logo}" x="${x}" y="${x}" width="${s}" height="${s}" preserveAspectRatio="xMidYMid meet"/>`;
    svg = svg.replace("</svg>", `${overlay}</svg>`);
  }
  return svg;
}

export async function buildPng(text, o, px = 2048) {
  const canvas = document.createElement("canvas");
  await QRCode.toCanvas(canvas, text, { ...qrOpts(o), width: px });
  if (o.logo) {
    const ctx = canvas.getContext("2d");
    const img = await loadImage(o.logo);
    const s = canvas.width * o.logoScale;
    const x = (canvas.width - s) / 2;
    const pad = s * 0.12;
    ctx.fillStyle = o.bg;
    ctx.beginPath();
    ctx.roundRect(x - pad, x - pad, s + 2 * pad, s + 2 * pad, pad);
    ctx.fill();
    const ratio = Math.min(s / img.width, s / img.height);
    const w = img.width * ratio;
    const h = img.height * ratio;
    ctx.drawImage(img, (canvas.width - w) / 2, (canvas.height - h) / 2, w, h);
  }
  return canvas.toDataURL("image/png");
}

export function download(href, filename) {
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
